<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <v-row>
      <v-col>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          color="primary"
        />
      </v-col>
    </v-row>
    <sequential-entrance from-top>
      <v-row>
        <v-col
          sm="12"
          md="12"
          lg="12"
        >
          <base-material-card
            color="primary"
            icon="mdi-group"
            inline
          >
            <template v-slot:after-heading>
              <div class="display-2 font-weight-light">
                Billing Rate Profiles
              </div>
            </template>
            <v-data-table
              :headers="headers"
              :items="getrels"
              :search="search"
              class="elevation-1"
            >
              <template v-slot:top>
                <v-toolbar
                  flat
                >
                  <v-toolbar-title>Billing Profiles</v-toolbar-title>
                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  />
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                  />
                  <v-spacer />
                  <v-dialog
                    v-model="dialog"
                    max-width="500px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        dark
                        class="mb-2"
                        v-bind="attrs"
                        v-on="on"
                      >
                        New Rate Profile
                      </v-btn>
                    </template>

                    <v-card>
                      <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-col>
                          <validation-observer
                            ref="observer"
                            v-slot="{ invalid }"
                          >
                            <form @submit.prevent="submit">
                              <validation-provider
                                v-slot="{ errors }"
                                name="Name"
                                rules="required|max:30"
                              >
                                <v-text-field
                                  v-model="editedItem.name"
                                  :error-messages="errors"
                                  label="Profile Name"
                                  required
                                />
                              </validation-provider>
                              <validation-provider
                                v-slot="{ errors }"
                                name="Base Rate"
                                rules="required|decimal:2"
                              >
                                <v-text-field
                                  v-model="editedItem.baserate"
                                  outlined
                                  :error-messages="errors"
                                  label="Base Rate"
                                  required
                                />
                              </validation-provider>
                              <validation-provider
                                v-slot="{ errors }"
                                name="Ship to site fee"
                                rules="required|decimal:2"
                              >
                                <v-text-field
                                  v-model="editedItem.sentshipmentfee"
                                  outlined
                                  :error-messages="errors"
                                  label="Ship to site fee"
                                  required
                                />
                              </validation-provider>
                              <validation-provider
                                v-slot="{ errors }"
                                name="Change Order fee"
                                rules="required|decimal:2"
                              >
                                <v-text-field
                                  v-model="editedItem.changeorderfee"
                                  outlined
                                  :error-messages="errors"
                                  label="Change Order fee"
                                  required
                                />
                              </validation-provider>
                              <validation-provider
                                v-slot="{ errors }"
                                name="Bag Track fee"
                                rules="required|decimal:2"
                              >
                                <v-text-field
                                  v-model="editedItem.bagtrackrate"
                                  outlined
                                  :error-messages="errors"
                                  label="Bag Track fee"
                                  required
                                />
                              </validation-provider>
                              <validation-provider
                                v-slot="{ errors }"
                                name="Platform Fee"
                                rules="required|decimal:2"
                              >
                                <v-text-field
                                  v-model="editedItem.platformfee"
                                  outlined
                                  :error-messages="errors"
                                  label="Platform Fee"
                                  required
                                />
                              </validation-provider>
                              <validation-provider
                                v-slot="{ errors }"
                                name="Rental Fee"
                                rules="required|decimal:2"
                              >
                                <v-text-field
                                  v-model="editedItem.rentalfee"
                                  outlined
                                  :error-messages="errors"
                                  label="Rental Fee"
                                  required
                                />
                              </validation-provider>
                              <validation-provider
                                v-slot="{ errors }"
                                name="Package Rate"
                                rules="required|decimal:2"
                              >
                                <v-text-field
                                  v-model="editedItem.packagerate"
                                  outlined
                                  :error-messages="errors"
                                  label="Package Rate"
                                  required
                                />
                              </validation-provider>
                              <validation-provider
                                v-slot="{ errors }"
                                name="Insurance Rate"
                                rules="required|decimal:2"
                              >
                                <v-text-field
                                  v-model="editedItem.insurancerate"
                                  outlined
                                  :error-messages="errors"
                                  label="Insurance Rate"
                                  required
                                  validate-on-blur
                                />
                              </validation-provider>
                              <v-btn
                                class="mr-4"
                                type="submit"
                                color="green"
                                :disabled="invalid || !formIsValid"
                                @click="save"
                              >
                                save
                              </v-btn>
                              <v-btn @click="close">
                                close
                              </v-btn>
                            </form>
                          </validation-observer>
                        </v-col>
                      </v-card-text>
                    </v-card>
                  </v-dialog>
                  <v-dialog
                    v-model="dialogDelete"
                    max-width="600px"
                  >
                    <v-card>
                      <v-card-title class="headline">
                        Are you sure you want to delete this item?
                      </v-card-title>
                      <v-card-actions>
                        <v-spacer />
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="closeDelete"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="deleteItemConfirm"
                        >
                          OK
                        </v-btn>
                        <v-spacer />
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-btn
                  small
                  class="mr-2 warning"
                  @click="editItem(item)"
                >
                  Edit Item
                </v-btn>
              </template>
              <template v-slot:no-data>
                <v-btn
                  color="primary"
                  @click="initialize"
                >
                  Reset
                </v-btn>
              </template>
            </v-data-table>
          </base-material-card>
        </v-col>
      </v-row>
    </sequential-entrance>
  </v-container>
</template>

<script>
  export default {
    data: () => ({
      dialog: false,
      dialogDelete: false,
      loctypes: ['postal', 'virtual', 'smartsafe', 'hybrid', 'bagtrack', 'change', 'other'],
      search: '',
      headers: [
        {
          text: 'Profile Name',
          align: 'start',
          sortable: true,
          value: 'name',
        },
        {
          text: 'Base Rate',
          align: 'center',
          sortable: true,
          value: 'baserate',
        },
        {
          text: 'Platform Fee',
          align: 'center',
          sortable: true,
          value: 'platformfee',
        },
        {
          text: 'Change Fee',
          align: 'center',
          sortable: true,
          value: 'changeorderfee',
        },
        {
          text: 'Rental Fee',
          align: 'center',
          sortable: true,
          value: 'rentalfee',
        },
        {
          text: 'Package Rate',
          align: 'center',
          sortable: true,
          value: 'packagerate',
        },
        {
          text: 'Insurance fee',
          align: 'center',
          sortable: true,
          value: 'insurancerate',
        },
        {
          text: 'Bag Tracking fee',
          align: 'center',
          sortable: true,
          value: 'bagtrackrate',
        },
        { text: 'Actions', value: 'actions', align: 'center', sortable: false },
      ],
      rels: [],
      editedIndex: -1,
      editedItem: {
        name: null,
        locationtype: null,
        baserate: null,
        changeorderfee: null,
        sentshipmentfee: '',
        platformfee: '',
        rentalfee: '',
        volumerate: '',
        packagerate: '',
        insurancerate: '',
        bagtrackrate: '',
        key: '',
      },
      defaultItem: {
        name: '',
        locationtype: '',
        baserate: '',
        changeorderfee: '',
        sentshipmentfee: '',
        platformfee: '',
        rentalfee: '',
        volumerate: '',
        packagerate: '',
        insurancerate: '',
        bagtrackrate: '',
        key: '',
      },
    }),

    computed: {
      formIsValid () {
        return this.editedItem.name !== '' &&
          this.editedItem.platformfee !== ''
      },
      formTitle () {
        return this.editedIndex === -1 ? 'New Billing Profile' : 'Edit Billing Profile'
      },
      loading () {
        // return true
        return this.$store.getters.getloading
      },
      getrels () {
        this.rels = []
        this.rels = this.$store.getters.getLoadedBillingProfiles
        return this.rels
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
      this.rels = []
      this.$store.dispatch('loadbillingprofiles')
      this.initialize()
    },

    methods: {
      initialize () {
        this.rels = this.$store.getters.getLoadedBillingProfiles
      },

      editItem (item) {
        this.editedIndex = this.rels.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.rels.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.rels.splice(this.editedIndex, 1)
        // no deleting
        // this.$store.dispatch('removerelease', this.editedItem)
        console.log('remove entry ', this.editedItem)
        this.closeDelete()
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.rels[this.editedIndex], this.editedItem)
          console.log('save this edited item ', this.editedItem)
          this.$store.dispatch('updatebillingprofile', this.editedItem)
        } else {
          this.rels.push(this.editedItem)
          console.log('save this new item ', this.editedItem)

          this.$store.dispatch('createbillingprofile', this.editedItem)
        }
        this.$store.dispatch('loadbillingprofiles')
        this.close()
      },
    },
  }
</script>
